<template>
  <div class="login-container">
    <div class="lang-switch" style="position: absolute; top: 20px; right: 20px; z-index: 100;">
      <a-dropdown>
        <a-button type="link" ghost style="color: rgba(255,255,255,0.8);">
          <a-icon type="global" style="font-size: 20px;" /> {{ $i18n.locale === 'zh-CN' ? '中文' : 'English' }} <a-icon type="down" />
        </a-button>
        <a-menu slot="overlay" @click="handleLangClick">
          <a-menu-item key="zh-CN">中文</a-menu-item>
          <a-menu-item key="en-US">English</a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <!-- 动态背景 -->
    <div class="animated-bg">
      <div class="glow-orb orb-1"></div>
      <div class="glow-orb orb-2"></div>
      <div class="glow-orb orb-3"></div>
      <div class="grid-overlay"></div>
    </div>

    <div class="login-content">
      <div class="brand-section">
        <div class="logo-wrapper" @click="$router.push('/')">
          <div class="logo-icon">X</div>
          <h1 class="brand-text">xxxxproxy</h1>
        </div>
        <p class="brand-slogan">{{ $t('login.slogan') }}</p>
      </div>

      <div class="login-card glass-effect">
        <div class="card-header">
          <h2>{{ $t('login.welcomeBack') }}</h2>
          <p>{{ $t('login.signInToContinue') }}</p>
        </div>

        <a-form-model :model="form" :rules="rules" ref="loginForm" class="login-form">
          <a-form-model-item prop="username">
            <div class="input-wrapper">
              <a-icon type="user" class="input-icon" />
              <a-input 
                v-model="form.username" 
                :placeholder="$t('login.usernamePlaceholder')" 
                size="large" 
                :bordered="false"
              />
            </div>
          </a-form-model-item>
          
          <a-form-model-item prop="password">
            <div class="input-wrapper">
              <a-icon type="lock" class="input-icon" />
              <a-input-password 
                v-model="form.password" 
                :placeholder="$t('login.passwordPlaceholder')" 
                size="large" 
                :bordered="false"
              />
            </div>
          </a-form-model-item>

          <a-form-model-item prop="verifyCode">
            <div class="captcha-row">
              <div class="input-wrapper captcha-input">
                <a-icon type="safety-certificate" class="input-icon" />
                <a-input 
                  v-model="form.verifyCode" 
                  :placeholder="$t('login.captchaPlaceholder')" 
                  size="large" 
                  :bordered="false"
                />
              </div>
              <div class="captcha-img-wrapper" @click="getCaptcha" title="点击刷新">
                <img :src="captchaUrl" alt="验证码" v-if="captchaUrl" />
                <div v-else class="captcha-placeholder">
                  <a-icon type="reload" />
                </div>
              </div>
            </div>
          </a-form-model-item>
          
          <div class="form-options">
            <a-checkbox v-model="form.remember">{{ $t('login.rememberMe') }}</a-checkbox>
            <a class="forgot-link">{{ $t('login.forgotPassword') }}</a>
          </div>
          
          <a-button 
            type="primary" 
            size="large" 
            block 
            class="submit-btn" 
            :loading="loading"
            @click="handleSubmit"
          >
            {{ $t('login.loginBtn') }}
          </a-button>
          
          <div class="register-link">
            {{ $t('login.noAccount') }} <router-link to="/register">{{ $t('login.registerNow') }}</router-link>
          </div>
        </a-form-model>
      </div>
    </div>
    
    <div class="footer-copyright">
      Copyright © {{ new Date().getFullYear() }} xxxxproxy. All Rights Reserved.
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'UserLogin',
  data() {
    return {
      captchaUrl: '',
      loading: false,
      form: {
        username: '',
        password: '',
        verifyCode: '',
        remember: true
      }
    };
  },
  computed: {
    rules() {
      return {
        username: [{ required: true, message: this.$t('login.inputUsername'), trigger: 'blur' }],
        password: [{ required: true, message: this.$t('login.inputPassword'), trigger: 'blur' }],
        verifyCode: [{ required: true, message: this.$t('login.inputCaptcha'), trigger: 'blur' }]
      };
    }
  },
  mounted() {
    this.getCaptcha();
  },
  methods: {
    handleLangClick({ key }) {
      this.$i18n.locale = key;
      localStorage.setItem('language', key);
    },
    getCaptcha() {
      request.get('/auth/captcha', { responseType: 'arraybuffer' })
        .then(res => {
          const data = res.data || res;
          if (data) {
            const base64 = btoa(new Uint8Array(data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            this.captchaUrl = `data:image/png;base64,${base64}`;
          }
        })
        .catch(err => {
          console.error('获取验证码失败:', err);
          this.$message.error('获取验证码失败');
        });
    },
    handleSubmit() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return;

        this.loading = true;
        try {
          const res = await request.post('/auth/login', {
            username: this.form.username,
            password: this.form.password,
            code: this.form.verifyCode,
            checked: this.form.remember,
            userType: 'xxxxproxy'
          });

          const { code, data, msg } = res.data || {};

          if (code === 200 && data) {
            localStorage.setItem('Token', data.token);
            localStorage.setItem('Authorization', data.token);
            localStorage.setItem('userName', this.form.username);
            localStorage.setItem('userId', data.uid);
            if (data.userInfo) {
              localStorage.setItem('subNumber', data.userInfo.subNumber);
            }
            this.$message.success("登录成功");
            this.$router.push('/dashboard/auth');
          } else {
            this.$message.warning(msg || "登录失败");
            this.getCaptcha();
          }
        } catch (error) {
          console.error('Login error:', error);
          this.$message.error(error.msg || '登录失败，请重试');
          this.getCaptcha();
        } finally {
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
// 变量定义
@primary-color: #1890ff;
@secondary-color: #69c0ff;
@bg-color: #0A192F;
@card-bg: rgba(255, 255, 255, 0.03);
@text-primary: #ffffff;
@text-secondary: rgba(255, 255, 255, 0.6);
@input-bg: rgba(0, 0, 0, 0.2);

.login-container {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: @bg-color;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

// 动态背景
.animated-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  
  .glow-orb {
    position: absolute;
    border-radius: 50%;
    filter: blur(80px);
    opacity: 0.4;
    animation: float 20s infinite ease-in-out;
  }
  
  .orb-1 {
    width: 400px;
    height: 400px;
    background: @primary-color;
    top: -100px;
    left: -100px;
    animation-delay: 0s;
  }
  
  .orb-2 {
    width: 500px;
    height: 500px;
    background: @secondary-color;
    bottom: -150px;
    right: -100px;
    animation-delay: -5s;
  }
  
  .orb-3 {
    width: 300px;
    height: 300px;
    background: #00B0FF;
    top: 40%;
    left: 40%;
    opacity: 0.2;
    animation-delay: -10s;
  }

  .grid-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
    background-size: 50px 50px;
    mask-image: radial-gradient(circle at center, black 40%, transparent 100%);
  }
}

@keyframes float {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(30px, -50px) scale(1.1); }
  66% { transform: translate(-20px, 20px) scale(0.9); }
}

.login-content {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 480px;
  padding: 20px;
}

.brand-section {
  text-align: center;
  margin-bottom: 40px;
  animation: slideDown 0.8s ease-out;

    .logo-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 12px;
      cursor: pointer;
      transition: transform 0.3s;
      
      &:hover {
        transform: scale(1.05);
      }
    }

  .logo-icon {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, @primary-color, @secondary-color);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-weight: bold;
    color: #fff;
    box-shadow: 0 0 20px rgba(0, 242, 254, 0.4);
    margin-right: 16px;
  }

  .brand-text {
    font-size: 36px;
    font-weight: 800;
    color: #fff;
    margin: 0;
    background: linear-gradient(to right, #fff, #a5b4fc);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: -1px;
  }

  .brand-slogan {
    color: @text-secondary;
    font-size: 16px;
    letter-spacing: 2px;
    margin: 0;
  }
}

.login-card {
  width: 100%;
  padding: 40px;
  border-radius: 24px;
  background: @card-bg;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  animation: zoomIn 0.6s ease-out 0.2s backwards;

  .card-header {
    text-align: center;
    margin-bottom: 30px;
    
    h2 {
      color: @text-primary;
      font-size: 24px;
      margin-bottom: 8px;
      font-weight: 600;
    }
    
    p {
      color: @text-secondary;
      font-size: 14px;
    }
  }
}

.input-wrapper {
  background: @input-bg;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding: 4px 16px;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.2);
  }
  
  &:focus-within {
    background: rgba(0, 0, 0, 0.4);
    border-color: @secondary-color;
    box-shadow: 0 0 0 2px rgba(79, 172, 254, 0.2);
    
    .input-icon {
      color: @secondary-color;
    }
  }

  .input-icon {
    color: rgba(255, 255, 255, 0.4);
    font-size: 18px;
    margin-right: 12px;
    transition: color 0.3s;
  }

  :deep(.ant-input) {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    color: #fff;
    font-size: 16px;
    padding-left: 0;
    
    &::placeholder {
      color: rgba(255, 255, 255, 0.3);
    }
  }
  
  :deep(.ant-input-password-icon) {
    color: rgba(255, 255, 255, 0.4);
    &:hover {
      color: #fff;
    }
  }
}

.captcha-row {
  display: flex;
  gap: 16px;
  
  .captcha-input {
    flex: 1;
  }
  
  .captcha-img-wrapper {
      min-width: 140px;
      height: 48px;
      border-radius: 12px;
      overflow: hidden;
      cursor: pointer;
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba(255, 255, 255, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
      
      &:hover {
        border-color: @secondary-color;
        opacity: 0.9;
      }
      
      img {
        width: 100%;
        height: 100%;
        object-fit: fill;
      }
    
    .captcha-placeholder {
      color: rgba(255, 255, 255, 0.5);
      font-size: 20px;
    }
  }
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  
  :deep(.ant-checkbox-wrapper) {
    color: @text-secondary;
    
    &:hover .ant-checkbox-inner {
      border-color: @secondary-color;
    }
    
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: @secondary-color;
      border-color: @secondary-color;
    }
    
    .ant-checkbox-inner {
      background-color: transparent;
      border-color: rgba(255, 255, 255, 0.3);
    }
  }
  
  .forgot-link {
    color: @secondary-color;
    transition: color 0.3s;
    
    &:hover {
      color: @primary-color;
    }
  }
}

.submit-btn {
  height: 50px;
  border-radius: 12px;
  background: linear-gradient(90deg, @secondary-color, @primary-color);
  border: none;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  box-shadow: 0 4px 15px rgba(79, 172, 254, 0.4);
  transition: all 0.3s;
  
  &:hover, &:focus {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(79, 172, 254, 0.5);
    background: linear-gradient(90deg, @primary-color, @secondary-color);
  }
  
  &:active {
    transform: translateY(0);
  }
}

.register-link {
  margin-top: 24px;
  text-align: center;
  color: @text-secondary;
  
  a {
    color: @secondary-color;
    font-weight: 600;
    margin-left: 5px;
    
    &:hover {
      color: @primary-color;
      text-decoration: underline;
    }
  }
}

.footer-copyright {
  position: absolute;
  bottom: 20px;
  width: 100%;
  text-align: center;
  color: rgba(255, 255, 255, 0.3);
  font-size: 12px;
  z-index: 10;
}

// 动画
@keyframes slideDown {
  from { opacity: 0; transform: translateY(-30px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes zoomIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}

// 响应式
@media (max-width: 576px) {
  .login-card {
    padding: 30px 20px;
  }
  
  .brand-text {
    font-size: 28px;
  }
  
  .orb-1, .orb-2 {
    opacity: 0.2;
  }
}
</style>
